let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jwYiv")).then(() => parcelRequire('6frTB'));